class StickyAtc {
  constructor(root) {
    this.root = root;
    this.image = root.querySelector('[data-sticky-image]');
    this.price = root.querySelector('[data-sticky-price]');
    this.compare = root.querySelector('[data-sticky-compare]');
    this.badge = root.querySelector('[data-sticky-badge]');
    this.submit = root.querySelector('[data-sticky-submit]');
    this.variantInput = root.querySelector('input[name="id"]');
    this.variants = JSON.parse(document.getElementById('StickyAtcVariants')?.textContent || '[]');
    this.mainForm = document.querySelector('form[data-type="add-to-cart-form"]');
    this.mainAtc = this.mainForm?.querySelector('button[name="add"]');
    this.mainVariantInput = this.mainForm?.querySelector('input[name="id"]');
    this.onScroll = () => this.handleScroll();
    this.init();
  }

  init() {
    if (!this.mainAtc) return;

    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onScroll);
    this.handleScroll();

    this.mainVariantInput?.addEventListener('change', () => {
      this.updateVariant(this.mainVariantInput.value);
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        if (event.data?.variant?.id) {
          this.updateVariant(event.data.variant.id);
        }
      });
    }
  }

  handleScroll() {
    const threshold =
      this.mainAtc.getBoundingClientRect().bottom + Number(this.root.dataset.offset || 0);

    if (window.scrollY > threshold) {
      this.root.classList.add('show');
      this.root.setAttribute('aria-hidden', 'false');
      document.documentElement.style.paddingBottom = `${this.root.clientHeight}px`;
    } else {
      this.root.classList.remove('show');
      this.root.setAttribute('aria-hidden', 'true');
      document.documentElement.style.paddingBottom = '0';
    }
  }

  updateVariant(variantId) {
    const variant = this.variants.find((item) => String(item.id) === String(variantId));
    if (!variant || !this.variantInput) return;

    this.variantInput.value = variant.id;
    this.variantInput.disabled = !variant.available;

    if (this.image && variant.image) {
      this.image.src = variant.image;
    }

    if (this.price) {
      this.price.textContent = variant.price_formatted;
    }

    if (this.compare) {
      if (variant.on_sale) {
        this.compare.textContent = variant.compare_formatted;
        this.compare.hidden = false;
      } else {
        this.compare.hidden = true;
      }
    }

    if (this.badge) {
      if (variant.on_sale) {
        this.badge.textContent = `${variant.discount_percent}% OFF`;
        this.badge.hidden = false;
      } else {
        this.badge.hidden = true;
      }
    }

    if (this.submit) {
      this.submit.disabled = !variant.available;
      const label = this.submit.querySelector('[data-sticky-submit-label]');
      if (label) {
        label.textContent = variant.available
          ? window.variantStrings?.addToCart || 'Add to cart'
          : window.variantStrings?.soldOut || 'Sold out';
      }
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const root = document.getElementById('md-sticky-atc');
  if (root) new StickyAtc(root);
});
